import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
    ShipmentExperienceProfile,
    ShipmentExperiencePreset,
    ShipmentQuickCreateRequest,
    ShipmentQuickCreateResponse
} from './shipment-experience.model';

@Injectable({ providedIn: 'root' })
export class ShipmentExperienceService {
    private readonly experienceUrl = `${environment.restApiUrl}shipment-experience`;
    private readonly quickUrl = `${environment.restApiUrl}shipments/quick`;

    constructor(private http: HttpClient) {}

    effective(): Observable<ShipmentExperienceProfile> {
        return this.http.get<ShipmentExperienceProfile>(`${this.experienceUrl}/effective`);
    }

    preset(presetCode: ShipmentExperiencePreset): Observable<ShipmentExperienceProfile> {
        return this.http.get<ShipmentExperienceProfile>(`${this.experienceUrl}/presets/${presetCode}`);
    }

    listProfiles(owningCompanyId: number): Observable<ShipmentExperienceProfile[]> {
        const params = new HttpParams().set('owningCompanyId', owningCompanyId);
        return this.http.get<ShipmentExperienceProfile[]>(`${this.experienceUrl}/profiles`, { params });
    }

    saveProfile(profile: ShipmentExperienceProfile): Observable<ShipmentExperienceProfile> {
        return this.http.post<ShipmentExperienceProfile>(`${this.experienceUrl}/profiles`, profile);
    }

    deactivateProfile(profileId: number): Observable<void> {
        return this.http.delete<void>(`${this.experienceUrl}/profiles/${profileId}`);
    }

    quickCreate(request: ShipmentQuickCreateRequest, idempotencyKey: string): Observable<ShipmentQuickCreateResponse> {
        const headers = new HttpHeaders().set('Idempotency-Key', idempotencyKey);
        return this.http.post<ShipmentQuickCreateResponse>(this.quickUrl, request, { headers });
    }
}
